import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformEuroCurrency',
})
export class TransformEuroCurrencyPipe implements PipeTransform {
  transform(value: string): string {
    //Si ponemos "es-ES" como locale no pone los puntos de los miles
    return value + ' €';
  }
}
